import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getApiConfig } from "@/settings/api";
import { ReducersTypes } from "@/redux/reducers/Models";

interface PixPaymentStatusResponse {
  // 0: pendente, 1: pago
  paymentStatus: 0 | 1;
  sqPagamento?: string;
  status: {
    codigoRetorno: number;
    mensagem: string;
    sessionId?: string;
  };
}

async function fetchPixPaymentStatus(
  transactionId: string,
  requestId: string,
  useAutomaticApi: boolean,
  prefixUri: string
): Promise<PixPaymentStatusResponse> {  
  const { apiInstance } = getApiConfig(useAutomaticApi);
  const { data } = await apiInstance.get(`${prefixUri}/v1/payments/${transactionId}/verification?requestId=${requestId}`);
  return data;
}

/**
 * Hook para consultar o status do pagamento Pix
 * @param transactionId - identificador da transação Pix
 * @param requestId - identificador único da requisição de passagens
 * @param enabled - se a consulta deve ser habilitada
 * @param options - opções adicionais para o useQuery
 */
export function usePixPaymentStatus(
  transactionId: string,
  requestId: string,
  enabled = true,
  options: {
    retry?: boolean;
    retryOnMount?: boolean;
    retryDelay?: number;
  } = {}
) {
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const user = useSelector((state: ReducersTypes) => state.userReducer);
  
  const hasCustomerToken = Boolean(customer?.accessToken);
  const hasUserToken = Boolean(user?.accessToken);
  
  const useAutomaticApi = hasCustomerToken;
  const { prefixUri } = getApiConfig(useAutomaticApi);
  
  const {
    retry = false,
    retryOnMount = false,
    retryDelay = 0
  } = options;
  
  return useQuery({
    queryKey: ["pix-payment-status", transactionId, useAutomaticApi, hasCustomerToken, hasUserToken],
    queryFn: () => {
      return fetchPixPaymentStatus(transactionId, requestId, useAutomaticApi, prefixUri);
    },
    enabled: !!transactionId && enabled,
    refetchInterval: false,
    retry,
    retryOnMount,
    retryDelay,
  });
} 